import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const OWNERSHIP_TYPES = [
  { key: 'direct', label: 'Direct', desc: 'Owned personally', selectedBorder: 'border-emerald-500', selectedBg: 'bg-emerald-50 text-emerald-700' },
  { key: 'indirect', label: 'Indirect', desc: 'Via entity', selectedBorder: 'border-blue-500', selectedBg: 'bg-blue-50 text-blue-700' },
  { key: 'related', label: 'Related', desc: 'Trust/Foundation', selectedBorder: 'border-indigo-500', selectedBg: 'bg-indigo-50 text-indigo-700' },
];

const EntitySelect = ({ label, sublabel, items, idField, value, onChange, emptyMessage }) => (
  <div className="mt-4">
    <Label className="portfolio-input-label">
      {label} <span className="text-red-500">*</span> <span className="text-xs text-slate-500">({sublabel})</span>
    </Label>
    {items.length === 0 ? (
      <div className="p-3 bg-amber-50 border border-amber-200 rounded-md text-sm text-amber-800 mt-2">
        {emptyMessage}
      </div>
    ) : (
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="portfolio-input mt-2">
          <SelectValue placeholder={`Select ${label.toLowerCase()}`} />
        </SelectTrigger>
        <SelectContent>
          {items.map((item) => (
            <SelectItem key={item[idField]} value={item[idField]}>
              {item.name} ({item.type} - {item.country})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    )}
  </div>
);

export const OwnershipTypeSelector = ({ ownerType, entityId, entities, relatedAssets, onOwnerTypeChange, onEntityChange }) => (
  <div className="border-t border-slate-200 pt-4">
    <Label className="portfolio-input-label mb-3 block">Investment Ownership <span className="text-red-500">*</span></Label>
    <div className="grid grid-cols-3 gap-3">
      {OWNERSHIP_TYPES.map(({ key, label, desc, selectedBorder, selectedBg }) => (
        <button
          key={key}
          type="button"
          onClick={() => onOwnerTypeChange(key)}
          className={`p-3 rounded-lg border-2 transition-all ${
            ownerType === key ? `${selectedBorder} ${selectedBg}` : 'border-slate-200 bg-white hover:border-slate-300'
          }`}
        >
          <div className="text-sm font-semibold">{label}</div>
          <div className="text-xs text-slate-500 mt-1">{desc}</div>
        </button>
      ))}
    </div>

    {ownerType === 'indirect' && (
      <EntitySelect label="Holding Entity" sublabel="Investment held through" items={entities} idField="entity_id"
        value={entityId} onChange={onEntityChange} emptyMessage={<>No holding entities found. Please create one in the <strong>Entities</strong> tab first.</>} />
    )}
    {ownerType === 'related' && (
      <EntitySelect label="Related Asset" sublabel="Trust or Foundation" items={relatedAssets} idField="asset_id"
        value={entityId} onChange={onEntityChange} emptyMessage={<>No related assets found. Please create one in the <strong>Entities</strong> tab first.</>} />
    )}
  </div>
);
